/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import { servicesRegisterUserLicenses } from '@/services/user-licenses'
import { useAuth0 } from '@auth0/auth0-react'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import ServicesTab from './components/ServicesTab'

const LicensesForm = ({
  licenses,
  setScreenLoader
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const [featurePricing, setFeaturePricing] = useState({})
  const [vaultPricing, setVaultPricing] = useState()
  const [licensesIdsSelected, setLicensesIdsSelected] = useState({})
  const getLicensesIdsSelected = (ids) => {
    setLicensesIdsSelected({ ...licensesIdsSelected, ...ids })
  }
  const getFeaturePrices = currentPricing => {
    setFeaturePricing({ ...featurePricing, ...currentPricing })
  }
  const vaultFeature = licenses && licenses[2]
  const featuresForForm = licenses && [licenses[0], licenses[1]]
  const registerLicenses = async () => {
    let licenseIds = []

    for (const key in licensesIdsSelected) {
      licenseIds = [...licenseIds, ...licensesIdsSelected[key]]
    }

    setScreenLoader(true)

    await servicesRegisterUserLicenses({ licenseIds }, getAccessToken)

    window.location.reload()
  }

  return (
    <div className="p-sm">
      <Tabs isFitted variant='enclosed'>
        <TabList mb='1em'>
          <Tab>Services</Tab>
          <Tab>License Template</Tab>
          <Tab>Manage User</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ServicesTab
              setVaultPricing={setVaultPricing}
              getLicensesIdsSelected={getLicensesIdsSelected}
              vaultFeature={vaultFeature}
              getFeaturePrices={getFeaturePrices}
              featuresForForm={featuresForForm}
              featurePricing={featurePricing}
              vaultPricing={vaultPricing}
              registerLicenses={registerLicenses}
            />
          </TabPanel>
          <TabPanel>
            <p>License Template content</p>
          </TabPanel>
          <TabPanel>
            <p>Manage User content</p>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  )
}

export default LicensesForm
